import styled from '@emotion/styled'

export const Wrapper = styled('div')({
  backgroundColor: '#fef3cd',
  borderRadius: '8px',
  padding: '1rem 1.25rem',
  display: 'flex',
  alignItems: 'flex-start',
  gap: '.75rem'
})

export const IconWrapper = styled('span')({
  color: '#d4a017',
  flexShrink: 0,
  marginTop: '2px'
})
